import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ServiceLookupRoute,
  ServiceLookupPathName,
} from '@/modules/ta/servicelookup/servicelookup.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ServiceLookupRoute.SERVICELOOKUPS}`,
      name: ServiceLookupPathName.SERVICELOOKUPS,
      component: () =>
        import(/* webpackChunkName: "servicelookup-page" */ './pages/ServiceLookupPage.vue'),
    },
    {
      path: `/${ServiceLookupRoute.SERVICELOOKUPS}/new`,
      name: ServiceLookupPathName.SERVICELOOKUPS_NEW,
      component: () =>
        import(
          /* webpackChunkName: "servicelookup-form-page" */ './pages/ServiceLookupFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ServiceLookupRoute.SERVICELOOKUPS}/:id`,
      name: ServiceLookupPathName.SERVICELOOKUPFORM,
      component: () =>
        import(
          /* webpackChunkName: "servicelookup-form-page" */ './pages/ServiceLookupFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.SERVICELOOKUP
);
